"use strict";
exports.__esModule = true;
exports.additionalSitemapPaths = exports.pagesSet = void 0;
var NotFoundTemplate = './src/templates/404.tsx';
var ActivationTemplate = './src/templates/activation.tsx';
var Unsupported = './src/templates/unsupported.tsx';
var AllInOneBusinessPlatformTemplate = './src/templates/all-in-one-business-platform.tsx';
var CanadaTemplate = './src/templates/canada.tsx';
var CoachingPhotographyTemplate = './src/templates/coaching-photography.tsx';
var ComparisonTemplate = './src/templates/comparison.jsx';
var TaxCalculatorTemplate = './src/templates/tax-calculator-page.tsx';
var EmailSignatureViewer = './src/templates/email-signature-viewer.tsx';
var InvitesTemplate = './src/templates/invites-page.jsx';
var DjBookingSoftwareTemplate = './src/templates/dj-booking-software.jsx';
var HealthCoachSoftwareTemplate = './src/templates/health-coach-software.jsx';
var OnlineInvoicesTemplate = './src/templates/online-invoices-new.tsx';
var OnlineContractTemplate = './src/templates/online-contract.tsx';
var CrmSEOTemplate = './src/templates/crm-seo.tsx';
var VerticalTemplate = './src/templates/vertical.tsx';
var InvoiceGeneratorTemplate = './src/templates/invoice-generator.tsx';
var ContractTemplateTemplate = './src/templates/contract-template.tsx';
var ContractsPerIndustry = './src/templates/contracts-per-industry.tsx';
var VerticalPaid = './src/templates/vertical-paid.tsx';
var EventPlannersTemplate = './src/templates/event-planners.jsx';
var EsignTemplate = './src/templates/esign.tsx';
var TemplatePreview = './src/templates/template-preview.tsx';
var ClientRelationshipsPage = './src/templates/client-relationships.tsx';
var redirectTemplate = './src/templates/redirect.tsx';
var pagesList = [
    {
        path: '/invites',
        excludeFromSitemap: true,
        component: InvitesTemplate,
        context: {}
    },
    {
        path: '/canada',
        component: CanadaTemplate,
        context: {
            isCtaTest: true
        }
    },
    {
        path: '/all-in-one-business-platform',
        component: AllInOneBusinessPlatformTemplate,
        context: {}
    },
    {
        path: '/coaching/photography/joy-michelle',
        excludeFromSitemap: true,
        component: CoachingPhotographyTemplate,
        context: {}
    },
    {
        path: '/honeybook-vs-dubsado',
        component: ComparisonTemplate,
        context: {
            contentKey: 'dubsado',
            isCtaTest: true
        }
    },
    {
        path: '/honeybook-vs-freshbooks',
        component: ComparisonTemplate,
        context: {
            contentKey: 'freshbooks',
            isCtaTest: true
        }
    },
    {
        path: '/honeybook-vs-bonsai',
        component: ComparisonTemplate,
        context: {
            contentKey: 'bonsai',
            isCtaTest: true
        }
    },
    {
        path: '/honeybook-vs-17hats',
        component: ComparisonTemplate,
        context: {
            contentKey: 'seventeenHats',
            isCtaTest: true
        }
    },
    {
        path: '/honeybook-vs-pipedrive',
        component: ComparisonTemplate,
        context: {
            contentKey: 'pipedrive',
            isCtaTest: true
        }
    },
    {
        path: '/honeybook-vs-monday',
        component: ComparisonTemplate,
        context: {
            contentKey: 'mondayDotCom',
            isCtaTest: true
        }
    },
    {
        path: '/honeybook-vs-vcita',
        component: ComparisonTemplate,
        context: {
            contentKey: 'vcita',
            isCtaTest: true
        }
    },
    {
        path: '/contracts-for-cinematographers',
        excludeFromSitemap: true,
        component: ContractsPerIndustry,
        context: {
            contentKey: 'cinematographers',
            isCtaTest: true
        }
    },
    {
        path: '/photography-contract-templates',
        component: ContractTemplateTemplate,
        context: {
            contentKey: 'photography',
            isCtaTest: true
        }
    },
    {
        path: '/designer-contract-template',
        component: ContractsPerIndustry,
        context: {
            contentKey: 'designer',
            isCtaTest: true
        }
    },
    {
        path: '/contracts-for-event-and-wedding-planners',
        excludeFromSitemap: true,
        component: ContractsPerIndustry,
        context: {
            contentKey: 'weddingPlanners',
            isCtaTest: true
        }
    },
    {
        path: '/dj-booking-software',
        component: DjBookingSoftwareTemplate,
        context: {
            isCtaTest: true
        }
    },
    {
        path: '/software-for-florists',
        component: VerticalTemplate,
        context: {
            contentKey: 'floristsPage'
        }
    },
    {
        path: '/all-in-one-software-for-cinematography',
        excludeFromSitemap: true,
        component: redirectTemplate,
        context: {
            url: '/crm/cinematographers'
        }
    },
    {
        path: '/all-in-one-software-for-wedding-photographers',
        excludeFromSitemap: true,
        component: VerticalTemplate,
        context: {
            contentKey: 'weddingPhotographersPage',
            isCtaTest: true
        }
    },
    {
        path: '/catering-management-software',
        component: VerticalTemplate,
        context: {
            contentKey: 'cateringPage'
        }
    },
    {
        path: '/doula-business-software',
        component: VerticalTemplate,
        context: {
            contentKey: 'doulaPage',
            isCtaTest: true
        }
    },
    {
        path: '/software-for-event-planners',
        component: EventPlannersTemplate,
        context: {}
    },
    {
        path: '/health-coach-software',
        component: HealthCoachSoftwareTemplate,
        context: {
            isCtaTest: true
        }
    },
    {
        path: '/build-contract',
        excludeFromSitemap: true,
        component: OnlineContractTemplate,
        context: {
            contentKey: 'buildContract',
            isCtaTest: true
        }
    },
    {
        path: '/contract-generator',
        excludeFromSitemap: true,
        component: OnlineContractTemplate,
        context: {
            contentKey: 'contractGenerator',
            isCtaTest: true
        }
    },
    {
        path: '/contract-maker',
        excludeFromSitemap: true,
        component: OnlineContractTemplate,
        context: {
            contentKey: 'contractMaker',
            isCtaTest: true
        }
    },
    {
        path: '/free-contract',
        excludeFromSitemap: true,
        component: OnlineContractTemplate,
        context: {
            contentKey: 'freeContractTemplates',
            isCtaTest: true
        }
    },
    {
        path: '/contract-agreement',
        excludeFromSitemap: true,
        component: OnlineContractTemplate,
        context: {
            contentKey: 'contractAgreement',
            isCtaTest: true
        }
    },
    {
        path: '/create-invoice',
        excludeFromSitemap: true,
        component: OnlineInvoicesTemplate,
        context: {
            contentKey: 'createInvoice'
        }
    },
    {
        path: '/free-invoice-template',
        excludeFromSitemap: true,
        component: OnlineInvoicesTemplate,
        context: {
            contentKey: 'freeInvoiceTemplate'
        }
    },
    {
        path: '/free-invoice-maker',
        excludeFromSitemap: true,
        component: OnlineInvoicesTemplate,
        context: {
            contentKey: 'freeInvoiceMaker'
        }
    },
    {
        path: '/free-invoice-generator',
        excludeFromSitemap: true,
        component: OnlineInvoicesTemplate,
        context: {
            contentKey: 'freeInvoiceGenerator'
        }
    },
    {
        path: '/create-free-invoice',
        excludeFromSitemap: true,
        component: OnlineInvoicesTemplate,
        context: {
            contentKey: 'createFreeInvoice'
        }
    },
    {
        path: '/free-invoice-software',
        excludeFromSitemap: true,
        component: OnlineInvoicesTemplate,
        context: {
            contentKey: 'freeInvoiceSoftware'
        }
    },
    {
        path: '/get-online-invoices',
        excludeFromSitemap: true,
        component: redirectTemplate,
        context: {
            url: '/product/online-invoices'
        }
    },
    {
        path: '/get-online-contract',
        excludeFromSitemap: true,
        component: redirectTemplate,
        context: {
            url: '/product/online-contract'
        }
    },
    {
        path: '/client-relationships',
        excludeFromSitemap: true,
        component: ClientRelationshipsPage,
        context: {
            contentKey: 'octGtm'
        }
    },
    {
        path: '/tools/self-employment-tax-calculator-california',
        component: TaxCalculatorTemplate,
        context: { USState: 'CA' }
    },
    {
        path: '/tools/self-employment-tax-calculator-texas',
        component: TaxCalculatorTemplate,
        context: { USState: 'TX' }
    },
    {
        path: '/tools/self-employment-tax-calculator-florida',
        component: TaxCalculatorTemplate,
        context: { USState: 'FL' }
    },
    {
        path: '/tools/self-employment-tax-calculator-new-york',
        component: TaxCalculatorTemplate,
        context: { USState: 'NY' }
    },
    {
        path: '/tools/self-employment-tax-calculator-pennsylvania',
        component: TaxCalculatorTemplate,
        context: { USState: 'PA' }
    },
    {
        path: '/tools/self-employment-tax-calculator-illinois',
        component: TaxCalculatorTemplate,
        context: { USState: 'IL' }
    },
    {
        path: '/tools/self-employment-tax-calculator-ohio',
        component: TaxCalculatorTemplate,
        context: { USState: 'OH' }
    },
    {
        path: '/tools/self-employment-tax-calculator-georgia',
        component: TaxCalculatorTemplate,
        context: { USState: 'GA' }
    },
    {
        path: '/tools/self-employment-tax-calculator-north-carolina',
        component: TaxCalculatorTemplate,
        context: { USState: 'NC' }
    },
    {
        path: '/tools/self-employment-tax-calculator-michigan',
        component: TaxCalculatorTemplate,
        context: { USState: 'MI' }
    },
    {
        path: '/email-signature-viewer',
        component: EmailSignatureViewer,
        context: {},
        excludeFromSitemap: true
    },
    {
        path: '/create-esignature',
        excludeFromSitemap: true,
        component: EsignTemplate,
        context: {
            contentKey: 'createESignature',
            isCtaTest: true
        }
    },
    {
        path: '/contract-singing-free',
        excludeFromSitemap: true,
        component: EsignTemplate,
        context: {
            contentKey: 'contractSingingFree',
            isCtaTest: true
        }
    },
    {
        path: '/sign-contracts-online',
        excludeFromSitemap: true,
        component: EsignTemplate,
        context: {
            contentKey: 'signContractsOnline',
            isCtaTest: true
        }
    },
    {
        path: '/digital-signature-creator',
        excludeFromSitemap: true,
        component: EsignTemplate,
        context: {
            contentKey: 'digitalSignatureCreator',
            isCtaTest: true
        }
    },
    {
        path: '/electronic-signature-free',
        excludeFromSitemap: true,
        component: EsignTemplate,
        context: {
            contentKey: 'electronicSignatureFree',
            isCtaTest: true
        }
    },
    {
        path: '/free-document-signing',
        excludeFromSitemap: true,
        component: EsignTemplate,
        context: {
            contentKey: 'freeDocumentSigning',
            isCtaTest: true
        }
    },
    /* Vertical */
    {
        path: '/marketing-consultant-software',
        component: VerticalTemplate,
        context: {
            contentKey: 'marketingPage'
        }
    },
    {
        path: '/software-for-online-coaching',
        excludeFromSitemap: true,
        component: VerticalTemplate,
        context: {
            contentKey: 'onlineCoachingPage',
            isCtaTest: true
        }
    },
    {
        path: '/software-for-band-managers',
        component: VerticalTemplate,
        context: {
            contentKey: 'bandManagersPage',
            isCtaTest: true
        }
    },
    {
        path: '/software-for-pr-companies',
        component: VerticalTemplate,
        context: {
            contentKey: 'PRPage',
            isCtaTest: true
        }
    },
    {
        path: '/software-for-web-designers',
        component: VerticalTemplate,
        context: {
            contentKey: 'webDesignersPage',
            isCtaTest: true
        }
    },
    {
        path: '/all-in-one-software-for-event-and-wedding-planners',
        excludeFromSitemap: true,
        component: VerticalTemplate,
        context: {
            contentKey: 'weddingPlannersPage'
        }
    },
    {
        path: '/all-in-one-software-for-event-rental-companies',
        excludeFromSitemap: true,
        component: VerticalTemplate,
        context: {
            contentKey: 'eventRentalsPage',
            isCtaTest: true
        }
    },
    {
        path: '/all-in-one-software-for-photographers',
        excludeFromSitemap: true,
        component: VerticalTemplate,
        context: {
            contentKey: 'allInOnePhotographersPage'
        }
    },
    {
        path: '/software-for-visual-artists',
        component: VerticalTemplate,
        context: {
            contentKey: 'visualArtistsPage',
            isCtaTest: true
        }
    },
    {
        path: '/software-for-dog-trainers',
        component: VerticalTemplate,
        context: {
            contentKey: 'dogTrainersPage',
            isCtaTest: true
        }
    },
    {
        path: '/software-for-agencies',
        component: VerticalTemplate,
        context: {
            contentKey: 'agenciesPage',
            isCtaTest: true
        }
    },
    {
        path: '/software-for-franchises',
        component: VerticalTemplate,
        context: {
            contentKey: 'franchisePage'
        }
    },
    {
        path: '/contractor-billing-software',
        component: VerticalTemplate,
        context: {
            contentKey: 'contractorPage',
            isCtaTest: true
        }
    },
    {
        path: '/tutor-software',
        component: VerticalTemplate,
        context: {
            contentKey: 'educationPage'
        }
    },
    {
        path: '/virtual-assistant-software',
        component: VerticalTemplate,
        context: {
            contentKey: 'virtualAssistantPage',
            isCtaTest: true
        }
    },
    {
        path: '/real-estate-crm-software',
        component: VerticalTemplate,
        context: {
            contentKey: 'realEstatePage',
            isCtaTest: true
        }
    },
    {
        path: '/social-media-crm',
        component: VerticalTemplate,
        context: {
            contentKey: 'socialMediaPage'
        }
    },
    {
        path: '/software-for-home-accountants',
        component: VerticalTemplate,
        context: {
            contentKey: 'homeAccountingPage',
            isCtaTest: true
        }
    },
    {
        path: '/interior-design-business-software',
        component: VerticalTemplate,
        context: {
            contentKey: 'interiorDesignPage'
        }
    },
    {
        path: '/tools-for-digital-marketers',
        component: VerticalTemplate,
        context: {
            contentKey: 'digitalMarketingPage'
        }
    },
    {
        path: '/software-for-copywriters',
        component: VerticalTemplate,
        context: {
            contentKey: 'copywritingPage',
            isCtaTest: true
        }
    },
    {
        path: '/life-coach-software',
        component: VerticalTemplate,
        context: {
            contentKey: 'lifeCoachPage',
            isCtaTest: true
        }
    },
    {
        path: '/software-for-cleaning-business',
        component: VerticalTemplate,
        context: {
            contentKey: 'cleaningPage',
            isCtaTest: true
        }
    },
    {
        path: '/all-in-one-software-for-estheticians-and-makeup-artists',
        excludeFromSitemap: true,
        component: VerticalTemplate,
        context: {
            contentKey: 'estheticiansPage',
            isCtaTest: true
        }
    },
    {
        path: '/all-in-one-software-for-hair-stylists',
        excludeFromSitemap: true,
        component: VerticalTemplate,
        context: {
            contentKey: 'hairStylistsPage',
            isCtaTest: true
        }
    },
    {
        path: '/all-in-one-software-for-photo-booth-rental-companies',
        excludeFromSitemap: true,
        component: VerticalTemplate,
        context: {
            contentKey: 'photoBoothsPage',
            isCtaTest: true
        }
    },
    {
        path: '/all-in-one-software-for-yoga-studios',
        excludeFromSitemap: true,
        component: redirectTemplate,
        context: {
            url: '/software-for-online-coaching'
        }
    },
    {
        path: '/all-in-one-software-for-teachers',
        excludeFromSitemap: true,
        component: VerticalTemplate,
        context: {
            contentKey: 'teachersPage',
            isCtaTest: true
        }
    },
    {
        path: '/all-in-one-software-for-officiants',
        excludeFromSitemap: true,
        component: VerticalTemplate,
        context: {
            contentKey: 'officiantsPage',
            isCtaTest: true
        }
    },
    {
        path: '/all-in-one-software-for-private-practice',
        excludeFromSitemap: true,
        component: VerticalTemplate,
        context: {
            contentKey: 'privatePracticePage',
            isCtaTest: true
        }
    },
    {
        path: '/all-in-one-software-for-lawyers',
        excludeFromSitemap: true,
        component: VerticalTemplate,
        context: {
            contentKey: 'lawyersPage',
            isCtaTest: true
        }
    },
    /* End of Vertical */
    {
        path: '/client-management-software',
        excludeFromSitemap: true,
        component: CrmSEOTemplate,
        context: {}
    },
    /* Redirect pages — no Gatsby Page View fires (immediate redirect); kept for URL continuity */
    {
        path: '/automations',
        excludeFromSitemap: true,
        component: redirectTemplate,
        context: {
            url: '/product/automations'
        }
    },
    {
        path: '/freelance-consulting-contract-template',
        component: ContractTemplateTemplate,
        context: {
            contentKey: 'consultants',
            isCtaTest: true
        }
    },
    {
        path: '/industry-event-planners',
        excludeFromSitemap: true,
        component: VerticalPaid,
        context: {
            contentKey: 'eventPlannersPage',
            isCtaTest: true
        }
    },
    {
        path: '/industry-creative-designer',
        excludeFromSitemap: true,
        component: VerticalPaid,
        context: {
            contentKey: 'creatives',
            isCtaTest: true
        }
    },
    {
        path: '/industry-cinematographers',
        excludeFromSitemap: true,
        component: VerticalPaid,
        context: {
            contentKey: 'cinematographers',
            isCtaTest: true
        }
    },
    {
        path: '/industry-videographers',
        excludeFromSitemap: true,
        component: VerticalPaid,
        context: {
            contentKey: 'videographers',
            isCtaTest: true
        }
    },
    {
        path: '/template-preview/:templateId',
        component: TemplatePreview,
        excludeFromSitemap: true,
        context: {}
    },
    {
        path: '/activation',
        component: ActivationTemplate,
        excludeFromSitemap: true,
        context: {}
    },
    {
        path: '/unsupported',
        component: Unsupported,
        excludeFromSitemap: true,
        context: {}
    },
    /* Redirect pages — no Gatsby Page View fires (immediate redirect); kept for URL continuity */
    {
        path: '/januaryjumpstart',
        excludeFromSitemap: true,
        component: redirectTemplate,
        context: {
            url: '/lp/january-jumpstart'
        }
    },
    {
        path: '/gettingstarted',
        excludeFromSitemap: true,
        component: redirectTemplate,
        context: {
            url: '/lp/getting-started'
        }
    },
    {
        path: '/email-generator',
        excludeFromSitemap: true,
        component: redirectTemplate,
        context: {
            url: 'https://tools.honeybook.com/free-email-templates/'
        }
    },
    {
        path: '/process-mapping',
        excludeFromSitemap: true,
        component: redirectTemplate,
        context: {
            url: 'https://tools.honeybook.com/process-mapping/'
        }
    },
    /* Invoice Generator */
    {
        path: '/free-invoice-templates/doula',
        component: InvoiceGeneratorTemplate,
        context: {
            contentKey: 'doula',
            isCtaTest: true
        }
    },
    {
        path: '/free-invoice-templates/graphic-design',
        component: InvoiceGeneratorTemplate,
        context: {
            contentKey: 'graphicDesign'
        }
    },
    {
        path: '/free-invoice-templates/interior-design',
        component: InvoiceGeneratorTemplate,
        context: {
            contentKey: 'interiorDesign',
            isCtaTest: true
        }
    },
    {
        path: '/free-invoice-templates/consultants',
        component: InvoiceGeneratorTemplate,
        context: {
            contentKey: 'consultants',
            isCtaTest: true
        }
    },
    {
        path: '/free-invoice-templates/photographers',
        component: InvoiceGeneratorTemplate,
        context: {
            contentKey: 'photographers',
            isCtaTest: true
        }
    },
    {
        path: '/free-invoice-templates/tutors',
        component: InvoiceGeneratorTemplate,
        context: {
            contentKey: 'tutors',
            isCtaTest: true
        }
    },
    {
        path: '/free-invoice-templates/cleaners',
        component: InvoiceGeneratorTemplate,
        context: {
            contentKey: 'cleaners',
            isCtaTest: true
        }
    },
    {
        path: '/free-invoice-templates/virtual-assistant',
        component: InvoiceGeneratorTemplate,
        context: {
            contentKey: 'virtualAssistant',
            isCtaTest: true
        }
    },
];
// 404 — Always last
pagesList.push({
    path: '/404',
    matchPath: '/*',
    component: NotFoundTemplate,
    excludeFromSitemap: true,
    context: {}
});
pagesList.forEach(function (page) {
    var _a;
    (_a = page.context).sourceFilePath || (_a.sourceFilePath = page.component);
});
exports.pagesSet = new Set(pagesList.map(function (page) { return page.path; }));
// Additional URLs (webflow/external pages not managed as gatsby pages) to include in sitemap-0.xml
exports.additionalSitemapPaths = [
    '/',
    '/alternatives',
    '/business-personality-test',
    '/business-type/design-creative-services',
    '/business-type/events',
    '/business-type/home-real-estate-services',
    '/business-type/marketing-advertising-services',
    '/business-type/personal-services',
    '/business-type/photographers',
    '/business-type/professional-services',
    '/business-type/venues',
    '/company/about',
    '/company/careers',
    '/company/contact-us',
    '/company/press',
    '/company/responsible-ai',
    '/crm/accountants',
    '/crm/architects',
    '/crm/caterers',
    '/crm/cinematographers',
    '/crm/coaches',
    '/crm/djs',
    '/crm/dog-trainers',
    '/crm/event-planners',
    '/crm/event-rentals',
    '/crm/florists',
    '/crm/franchises',
    '/crm/freelancers',
    '/crm/graphic-designers',
    '/crm/hair-stylists',
    '/crm/interior-designers',
    '/crm/it-consultants',
    '/crm/landscapers',
    '/crm/lawyers',
    '/crm/marketing-agencies',
    '/crm/personal-trainers',
    '/crm/photographers',
    '/crm/publishers',
    '/crm/social-media',
    '/crm/tattoo-artists',
    '/crm/therapists',
    '/crm/travel-agents',
    '/crm/venues',
    '/crm/virtual-assistants',
    '/crm/wedding-planners',
    '/for-teams',
    '/legal/privacy',
    '/legal/subpoena-policy',
    '/legal/terms-of-service',
    '/meeting-scheduler',
    '/proposal-software',
    '/online-contract',
    '/online-document-signing',
    '/partnerships/referrals',
    '/pricing',
    '/product/ai',
    '/product/automations',
    '/product/business-messaging',
    '/product/integrations/chatgpt',
    '/product/crm',
    '/product/finance',
    '/product/free-account-migration',
    '/product/integrations',
    '/product/integrations/activecampaign',
    '/product/integrations/anthropic',
    '/product/integrations/asana',
    '/product/integrations/calendly',
    '/product/integrations/canva',
    '/product/integrations/clickup',
    '/product/integrations/cloudspot',
    '/product/integrations/dropbox',
    '/product/integrations/facebook-conversions',
    '/product/integrations/flodesk',
    '/product/integrations/freshbooks',
    '/product/integrations/gmail',
    '/product/integrations/google-ads',
    '/product/integrations/google-calendar',
    '/product/integrations/google-docs',
    '/product/integrations/google-forms',
    '/product/integrations/google-sheets',
    '/product/integrations/kajabi',
    '/product/integrations/leadconnector',
    '/product/integrations/mailchimp',
    '/product/integrations/monday',
    '/product/integrations/motion',
    '/product/integrations/outlook',
    '/product/integrations/prismm',
    '/product/integrations/quickbooks',
    '/product/integrations/quo',
    '/product/integrations/slack',
    '/product/integrations/square',
    '/product/integrations/squarespace',
    '/product/integrations/stripe',
    '/product/integrations/todoist',
    '/product/integrations/typeform',
    '/product/integrations/vibo',
    '/product/integrations/wave',
    '/product/integrations/wix',
    '/product/integrations/zapier',
    '/product/integrations/zoho',
    '/product/integrations/zoom',
    '/product/meeting-scheduler',
    '/product/online-contract',
    '/product/online-invoices',
    '/product/online-payment-software',
    '/product/payment-reminders',
    '/product/proposal-software',
    '/resources',
    '/reviews',
    '/sitemap',
    '/switch',
    '/whyhoneybook',
];
exports["default"] = pagesList;
